import {B2BDocumentTypeList, DocumentTypeList, InvoiceHistoryList, StateInvoices} from '../../invoices.model';

import {ActionReducerMap} from '@ngrx/store';
import {StateUtils} from '@spartacus/core';
import {InjectionToken} from '@angular/core';
import {reducerInvoiceHistoryList} from '../../custom-invoice-history/store/reducers/custom-invoices-history.reducer';
import {INVOICES} from '../../custom-invoice-history/store/actions/custom-invoices-history.actions';
import {reducerDocumentTypes} from '../../custom-invoice-history/store/reducers/custom-invoices-document-types.reducer';
import {INVOICES_DOCUMENT_TYPES} from '../../custom-invoice-history/store/actions/custom-invoices-document-types.actions';
import {INVOICE_LIST_SELECTOR} from '../../custom-invoice-history/store/selectors/custom-invoice-history.selector';
import {INVOICES_DOCUMENT_TYPE_SELECTOR} from '../../custom-invoice-history/store/selectors/custom-invoice-document-type.selector';


export function getReducers(): ActionReducerMap<StateInvoices> {
  return {
    [INVOICE_LIST_SELECTOR]: StateUtils.loaderReducer<InvoiceHistoryList>(INVOICES, reducerInvoiceHistoryList),
    [INVOICES_DOCUMENT_TYPE_SELECTOR]: StateUtils.loaderReducer<B2BDocumentTypeList>(INVOICES_DOCUMENT_TYPES, reducerDocumentTypes)
  };
}


export const invoiceReducerToken: InjectionToken<ActionReducerMap<StateInvoices>> =
  new InjectionToken<ActionReducerMap<StateInvoices>>('InvoicesReducer');


export const reducerInvoiceProvider = {
  provide: invoiceReducerToken,
  useFactory: getReducers
};

